import { parseDate } from '@internationalized/date';
import { AxiosError } from 'axios';
import useSWR from 'swr';

import { camelizeKeys, WithStatusT } from '@consumer-frontend/nc-utils';

import { apiEndpoints } from '../lib';

export type UseBillingPeriodsPropsT = {
  accountId: string;
  loanNumber?: string;
};

type BillingPeriodT = {
  due_date: string;
  end_date: string;
  is_billable: boolean;
  is_current: boolean;
  start_date: string;
};

export type BillingPeriodsCamelizedT = {
  dueDate: string;
  endDate: string;
  isBillable: boolean;
  isCurrent: boolean;
  startDate: string;
};

type BillingPeriodsResponseT = {
  billing_periods: BillingPeriodT[];
};

export const useBillingPeriods = ({ accountId, loanNumber }: UseBillingPeriodsPropsT) => {
  // eslint-disable-next-line @stylistic/object-curly-newline
  const { data, error, isLoading } = useSWR<WithStatusT<BillingPeriodsResponseT>, AxiosError>(
    () => (accountId && loanNumber ? apiEndpoints.dashboard.billingPeriods(accountId, loanNumber) : null),
  );

  const billingPeriods = data?.billing_periods?.map((billingPeriod) => ({
    ...camelizeKeys<BillingPeriodT, BillingPeriodsCamelizedT>(billingPeriod),
    dueDate: parseDate(billingPeriod.due_date),
    endDate: parseDate(billingPeriod.end_date),
    startDate: parseDate(billingPeriod.start_date),
  }));

  const currentBillingPeriod = billingPeriods?.find((period) => period.isCurrent);

  return {
    billingPeriods,
    currentBillingPeriod,
    error,
    isLoading,
    status: data?.status || error?.status,
  };
};
